import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  UniqueAppNamePickerField,
  validateUniqueAppName,
} from './UniqueAppNamePickerField';

const uniqueAppNamePickerFormField = FormFieldBlueprint.make({
  name: 'unique-app-name-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'UniqueAppNamePicker',
        component: UniqueAppNamePickerField,
        validation: validateUniqueAppName,
      }),
  },
});

export const scaffolderAppNamePickerModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [uniqueAppNamePickerFormField],
});
